// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import packageInfo from 'package.json';

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyD1nJ5By2gbXAIei9xwkfNH3VOWl8Y5dU4",
    authDomain: "ecoacsa-develop.firebaseapp.com",
    projectId: "ecoacsa-develop",
    storageBucket: "ecoacsa-develop.appspot.com",
    messagingSenderId: "374065550274",
    appId: "1:374065550274:web:4e4df0122fbe76ac30bc5b",
    region: 'europe-west1',
  },
  version: packageInfo.version,     
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
